import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  fetchRestaurantOpenDays,
  patchRestaurantOpenDays,
  createRestaurantOpenDays,
  fetchHoursEach,
} from "../../actions/restaurantActions";
import DropDownButton from "../../components/DropDownButton";
import CustomSelectArray from "../CustomSelectArray";
import { api } from "../../App";
import {
  CustomModal,
  CloseIcon,
  ModernButton,
  InlineText,
  InsideFormGroup,
  FormGroup,
  Input,
  ModalOverlay,
  StyledLabel,
} from "../../components/DefaultImports";
import TimeRangePicker from "../inputs/TimeRangePicker";
import { ConfirmationModal } from "../ConfirmationModal";
import SwitchOnAndOff from "../SwitchOnAndOff";

const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #75726f;
  border: 1px solid #75726f;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;
  transition:
    background-color 0.2s,
    border-color 0.2s;
  &:hover {
    background-color: #474645;
    border-color: #474645;
  }
`;

function TimeManagement({
  shiftId = null,
  mode = "create",
  scheduleType = "regular",
  restaurantId,
  showModal,
  setShowModal,
}) {
  const [timeStart, setTimeStart] = useState("12:00");
  const [timeEnd, setTimeEnd] = useState("22:00");
  const [shift, setShift] = useState("Dinner");
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [switchZones, setSwitchZones] = useState(
    mode === "create" ? false : true,
  );
  const [zone_list, setZone_list] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [accept_people_per_each_time, setAccept_people_per_each_time] =
    useState(20);
  const [eachTime, setEachTime] = useState("00:15");

  const dispatch = useDispatch();
  const hoursEachTime = useSelector((state) => state.hoursEachTime);
  const { hoursEach } = hoursEachTime;

  const openDayss = useSelector((state) => state.restaurantOpenDaysOfTheWeek);
  const { openDays, isLoadingOpenDays } = openDayss;
  const restaurantZones = useSelector((state) => state.restaurantZones);
  const { zones = [] } = restaurantZones;

  useEffect(() => {
    dispatch(fetchHoursEach(restaurantId));
  }, [dispatch, restaurantId]);

  useEffect(() => {
    const placeOfTables = zones.map((zone) => zone.place_of_table);
    setZone_list(placeOfTables);
    if (!switchZones) {
      setSelectedZones(placeOfTables);
    }
  }, [zones, switchZones]);

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "12:00";
    const time = timeString.slice(0, 5);
    return time.length === 5 ? time : "12:00";
  };

  useEffect(() => {
    if (mode === "edit" && shiftId && openDays.length > 0) {
      const openDay = openDays.find((day) => day.id === shiftId);
      if (openDay) {
        setShift(openDay.shift);

        setTimeStart(openDay.start_time.slice(0, 5));
        setTimeEnd(openDay.end_time.slice(0, 5));
        setAccept_people_per_each_time(openDay.accept_people_per_each_time);
        setEachTime(openDay.each_time);
        setSelectedZones(openDay.list_of_zones.split(",") || []);

        const selected = [];
        if (openDay.Monday) selected.push("Segunda");
        if (openDay.Tuesday) selected.push("Terça");
        if (openDay.Wednesday) selected.push("Quarta");
        if (openDay.Thursday) selected.push("Quinta");
        if (openDay.Friday) selected.push("Sexta");
        if (openDay.Saturday) selected.push("Sábado");
        if (openDay.Sunday) selected.push("Domingo");

        setSelectedItems(selected);
      }
    }
  }, [mode, shiftId, openDays]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const openDaysDataToSubmit = {
      restaurant: restaurantId,
      start_time: timeStart,
      end_time: timeEnd,
      Monday: selectedItems.includes("Segunda"),
      Tuesday: selectedItems.includes("Terça"),
      Wednesday: selectedItems.includes("Quarta"),
      Thursday: selectedItems.includes("Quinta"),
      Friday: selectedItems.includes("Sexta"),
      Saturday: selectedItems.includes("Sábado"),
      Sunday: selectedItems.includes("Domingo"),
      accept_people_per_each_time: Number(accept_people_per_each_time),
      each_time: eachTime,
      list_of_zones: selectedZones.join(","),
    };

    if (mode === "edit") {
      dispatch(
        patchRestaurantOpenDays(restaurantId, shiftId, openDaysDataToSubmit),
      );
    } else {
      dispatch(createRestaurantOpenDays(restaurantId, openDaysDataToSubmit));
    }

    setShowModal(false);
  };

  const deleteOpenDay = async () => {
    try {
      await api.delete(`restaurants/${restaurantId}/opentimes/${shiftId}/`);
      dispatch(fetchRestaurantOpenDays(restaurantId));
      setShowModal(false);
      setShowDeleteModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectZones = (newSelectedItems) => {
    setSelectedZones(newSelectedItems);
  };

  const weekdayDisplayMap = {
    Segunda: "Segunda-feira",
    Terça: "Terça-feira",
    Quarta: "Quarta-feira",
    Quinta: "Quinta-feira",
    Sexta: "Sexta-feira",
    Sábado: "Sábado", // No -feira needed
    Domingo: "Domingo", // No -feira needed
  };

  const displayToInternal = (label) => {
    return (
      Object.keys(weekdayDisplayMap).find(
        (key) => weekdayDisplayMap[key] === label,
      ) || label
    );
  };

  const internalToDisplay = (key) => weekdayDisplayMap[key] || key;

  return (
    <div>
      <form onSubmit={handleFormSubmit}>
        <div>
          <StyledLabel htmlFor="weekdays">Dias da semana</StyledLabel>
          <CustomSelectArray
            items={Object.values(weekdayDisplayMap)} // UI shows -feira
            selectedItems={selectedItems.map(internalToDisplay)} // convert for display
            onSelectChange={
              (newDisplayValues) =>
                setSelectedItems(newDisplayValues.map(displayToInternal)) // convert back for backend
            }
            size="large"
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <StyledLabel>Horário do turno</StyledLabel>
          <TimeRangePicker
            startTime={timeStart}
            endTime={timeEnd}
            onChange={(times) => {
              setTimeStart(times[0]);
              setTimeEnd(times[1]);
            }}
          />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <FormGroup>
            <InsideFormGroup>
              <StyledLabel>Controlar chegada de clientes</StyledLabel>
              <InlineText>Permitir no total</InlineText>
              <Input
                type="number"
                id="accept_people_per_each_time"
                name="accept_people_per_each_time"
                value={accept_people_per_each_time}
                onChange={(e) => setAccept_people_per_each_time(e.target.value)}
              />
              <InlineText>pessoas a cada</InlineText>
              <DropDownButton
                options={["00:15", "00:30", "00:45"]}
                handleOptionChange={(selected) => setEachTime(selected)}
                initialOption={eachTime}
              />
              <InlineText>minutos</InlineText>
            </InsideFormGroup>
          </FormGroup>

          <FormGroup></FormGroup>
          <FormGroup controlId="zones">
            <StyledLabel>Selecionar salas</StyledLabel>
            <CustomSelectArray
              items={zone_list}
              onSelectChange={handleSelectZones}
              selectedItems={selectedZones}
              size="large"
            />
          </FormGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "16px",
          }}
        >
          {mode === "edit" && (
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              type="button"
              onClick={() => setShowDeleteModal(true)}
            >
              Apagar
            </ModernButton>
          )}
          <ModernButton color="#ff704d" fontSize="14px" type="submit">
            Gravar
          </ModernButton>
        </div>
      </form>

      <ConfirmationModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={deleteOpenDay}
        title="Eliminar turno"
        body="Tem a certeza que deseja eliminar este turno?"
        confirmLabel="Confirmar"
        confirmColor="#ff704d"
        cancelLabel="Cancelar"
        cancelColor="#99b0ad"
        centered={false}
        topSpacing={"150px auto"}
      />
    </div>
  );
}

export default TimeManagement;
